import styled from "styled-components/macro";

import workflow_bg from "../../assets/images/workflow_img.png"

export const WorkflowShell = styled.div`
  position: relative;
  width: 100%;
`

export const WorkflowScroll = styled.div`
  width: 100%;
  margin-top: 34px;

  @media (max-width: 1023px) {
    margin-top: 13px;
    padding-top: 21px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const WorkflowIndicator = styled.div`
  position: absolute;
  left: 50%;
  bottom: 150px;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 2;

  @media (max-width: 1023px) {
    display: flex;
  }
`

export const WorkflowIndicatorSegment = styled.span<{ $isActive: boolean }>`
  display: block;
  flex: 0 0 39px;
  width: 39px;
  height: 2px;
  background-color: #FFFFFF;
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.3)};
  transition: opacity 0.2s ease;
`

export const WorkflowCanvas = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 1023px) {
    width: max-content;
    min-width: 100%;
  }
`

export const WorkflowBgFrame = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 150%;
    aspect-ratio: 2107 / 551;
    background-image: url(${workflow_bg});
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 979px) {
    &::before {
      left: 54%;
      width: 110%;
    }
  }
`

export const WorkflowList = styled.ul`
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 550px;
  display: flex;
  border-top: 1px dashed #A9A9A9;

  @media (max-width: 1023px) {
    min-height: 350px;
  }
`

export const WorkflowItem = styled.li`
  flex: 1 1 189px;
  min-width: 189px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 46px 26px 0 0;
  position: relative;

  @media (max-width: 1023px) {
    flex: 0 0 189px;
  }
`

export const NumberCircle = styled.div`
  position: absolute;
  top: -21px;
  left: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgb(35, 34, 41);
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
`

// export const Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//
//   @media (max-width: 979px) {
//     width: 100%;
//     flex-direction: row;
//     justify-content: flex-start;
//     align-items: center;
//     gap: 10px;
//     margin-bottom: 16px;
//   }
// `

// export const NumberBlock = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   margin-bottom: 18px;
//
//   @media (max-width: 979px) {
//     margin-bottom: 0;
//   }
// `

// export const Circle = styled.div<{color: string}>`
//   width: 8px;
//   height: 8px;
//   border-radius: 50%;
//   background-color: ${({ color }) => color};
// `

export const Number  = styled.span`
  font-size: 18px;
  line-height: 140%;
`

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
    
  @media (max-width: 979px) {
    flex-direction: row;
  }
`

export const Title = styled.span`
  font-family: "Cormorant Infant", sans-serif;
  font-weight: 600;
  line-height: 86%;
  font-size: 40px;
  color: #fff;
    
  @media (max-width: 1439px) {
    font-size: 35px;
  }

  @media (max-width: 979px) {
    font-size: 30px;
    margin-right: 5px;
  }
`

export const Desc = styled.span`
  font-size: 18px;
  line-height: 140%;
  color: #B4B4B4;
  
  @media (max-width: 979px) {
    text-align: left;
    font-size: 15px;
  }
`
